import React from "react";

// @ts-ignore
import Atticus from "../assets/Atticus.png";
// @ts-ignore
import Atticus15 from "../assets/Atticus-1.5x.png";
// @ts-ignore
import Atticus2 from "../assets/Atticus-2x.png";
// @ts-ignore
import Atticus3 from "../assets/Atticus-3x.png";

export interface Props {
  width?: string;
  title?: string;
}

export const AtticusLogo = ({ width, title }: Props): JSX.Element => {
  return (
    <img
      srcSet={`${Atticus15} 1.5x, ${Atticus2} 2x, ${Atticus3} 3x`}
      src={Atticus}
      alt={title || "Atticus"}
      title={title || "Atticus"}
      width={width || "100"}
    />
  );
};
